import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import SmartphoneIcon from '@mui/icons-material/Smartphone'
import LaptopMacIcon from '@mui/icons-material/LaptopMac'
import TabletMacIcon from '@mui/icons-material/TabletMac'
import { useTranslation } from 'react-i18next'
import invert from 'lodash/invert'

import { useToolBuilder } from 'containers/ToolBuilder/Hook'
import { useAppSelector } from 'redux/Hook'

function DeviceViewButtons({ livePreviewWidth, setLivePreviewWidth }: any) {
  const { t } = useTranslation()
  const { toolId, toolType, isMd } = useToolBuilder()
  const { fetching, saving } = useAppSelector((state) => state.toolBuilder)

  if (isMd) return null

  const mappings: Record<string, string> = {
    mobile: '414px',
    desktop: '100%',
    tab: '768px',
  }

  const handleChange = (_: any, newValue: string) => {
    setLivePreviewWidth(mappings[newValue] || '100%')
  }

  return (
    <ToggleButtonGroup
      aria-label={`${t('toolBuilder.viewOnDevice')}`}
      value={invert(mappings)[livePreviewWidth] || 'desktop'}
      exclusive
      onChange={handleChange}
      disabled={!toolId || !toolType || fetching || saving}
      size="small"
    >
      <ToggleButton
        value="mobile"
        aria-label={t('toolBuilder.viewOnSmartphone')}
      >
        <SmartphoneIcon />
      </ToggleButton>
      <ToggleButton value="desktop" aria-label={t('toolBuilder.viewOnDesktop')}>
        <LaptopMacIcon />
      </ToggleButton>
      <ToggleButton value="tab" aria-label={t('toolBuilder.viewOnTablet')}>
        <TabletMacIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default DeviceViewButtons
